module.exports = __webpack_public_path__ + "static/media/user.fbd4a4ad.png";